export default __webpack_public_path__ + "static/media/timeline-08-animated.db7b26e7.gif";